"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTrashedFieldsPaginatedExpandEnum = exports.GetFieldsPaginatedOrderByEnum = exports.GetFieldsPaginatedTypeEnum = exports.IssueFieldsApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class IssueFieldsApi extends runtime.BaseAPI {
    /**
     * Creates a custom field.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create custom field
     */
    createCustomFieldRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['customFieldDefinitionJsonBean'] == null) {
                throw new runtime.RequiredError('customFieldDefinitionJsonBean', 'Required parameter "customFieldDefinitionJsonBean" was null or undefined when calling createCustomField().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CustomFieldDefinitionJsonBeanToJSON)(requestParameters['customFieldDefinitionJsonBean']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.FieldDetailsFromJSON)(jsonValue));
        });
    }
    /**
     * Creates a custom field.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create custom field
     */
    createCustomField(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCustomFieldRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a custom field. The custom field is deleted whether it is in the trash or not. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  This operation is [asynchronous](#async). Follow the `location` link in the response to determine the status of the task and use [Get task](#api-rest-api-3-task-taskId-get) to obtain subsequent updates.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete custom field
     */
    deleteCustomFieldRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteCustomField().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a custom field. The custom field is deleted whether it is in the trash or not. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  This operation is [asynchronous](#async). Follow the `location` link in the response to determine the status of the task and use [Get task](#api-rest-api-3-task-taskId-get) to obtain subsequent updates.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete custom field
     */
    deleteCustomField(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deleteCustomFieldRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a [paginated](#pagination) list of the contexts a field is used in. Deprecated, use [ Get custom field contexts](#api-rest-api-3-field-fieldId-context-get).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get contexts for a field
     * @deprecated
     */
    getContextsForFieldDeprecatedRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling getContextsForFieldDeprecated().');
            }
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-project"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/contexts`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanContextFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of the contexts a field is used in. Deprecated, use [ Get custom field contexts](#api-rest-api-3-field-fieldId-context-get).  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get contexts for a field
     * @deprecated
     */
    getContextsForFieldDeprecated(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContextsForFieldDeprecatedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns system and custom issue fields according to the following rules:   *  Fields that cannot be added to the issue navigator are always returned.  *  Fields that cannot be placed on an issue screen are always returned.  *  Fields that depend on global Jira settings are only returned if the setting is enabled. That is, timetracking fields, subtasks, votes, and watches.  *  For all other fields, this operation only returns the fields that the user has permission to view (that is, the field is used in at least one project that the user has *Browse Projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for.)  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** None.
     * Get fields
     */
    getFieldsRaw(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(index_1.FieldDetailsFromJSON));
        });
    }
    /**
     * Returns system and custom issue fields according to the following rules:   *  Fields that cannot be added to the issue navigator are always returned.  *  Fields that cannot be placed on an issue screen are always returned.  *  Fields that depend on global Jira settings are only returned if the setting is enabled. That is, timetracking fields, subtasks, votes, and watches.  *  For all other fields, this operation only returns the fields that the user has permission to view (that is, the field is used in at least one project that the user has *Browse Projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for.)  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** None.
     * Get fields
     */
    getFields(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFieldsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of fields for Classic Jira projects. The list can include:   *  all fields  *  specific fields, by defining `id`  *  fields that contain a string in the field name or description, by defining `query`  *  specific fields that contain a string in the field name or description, by defining `id` and `query`  Only custom fields can be queried, `type` must be set to `custom`.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get fields paginated
     */
    getFieldsPaginatedRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            if (requestParameters['query'] != null) {
                queryParameters['query'] = requestParameters['query'];
            }
            if (requestParameters['orderBy'] != null) {
                queryParameters['orderBy'] = requestParameters['orderBy'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/search`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanFieldFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of fields for Classic Jira projects. The list can include:   *  all fields  *  specific fields, by defining `id`  *  fields that contain a string in the field name or description, by defining `query`  *  specific fields that contain a string in the field name or description, by defining `id` and `query`  Only custom fields can be queried, `type` must be set to `custom`.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get fields paginated
     */
    getFieldsPaginated(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFieldsPaginatedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of fields in the trash. The list may be restricted to fields whose field name or description partially match a string.  Only custom fields can be queried, `type` must be set to `custom`.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get fields in trash paginated
     */
    getTrashedFieldsPaginatedRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            if (requestParameters['query'] != null) {
                queryParameters['query'] = requestParameters['query'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            if (requestParameters['orderBy'] != null) {
                queryParameters['orderBy'] = requestParameters['orderBy'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/search/trashed`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanFieldFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of fields in the trash. The list may be restricted to fields whose field name or description partially match a string.  Only custom fields can be queried, `type` must be set to `custom`.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get fields in trash paginated
     */
    getTrashedFieldsPaginated(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTrashedFieldsPaginatedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restores a custom field from trash. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Restore custom field from trash
     */
    restoreCustomFieldRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling restoreCustomField().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{id}/restore`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Restores a custom field from trash. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Restore custom field from trash
     */
    restoreCustomField(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.restoreCustomFieldRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Moves a custom field to trash. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Move custom field to trash
     */
    trashCustomFieldRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling trashCustomField().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{id}/trash`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Moves a custom field to trash. See [Edit or delete a custom field](https://confluence.atlassian.com/x/Z44fOw) for more information on trashing and deleting custom fields.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Move custom field to trash
     */
    trashCustomField(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.trashCustomFieldRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates a custom field.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update custom field
     */
    updateCustomFieldRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling updateCustomField().');
            }
            if (requestParameters['updateCustomFieldDetails'] == null) {
                throw new runtime.RequiredError('updateCustomFieldDetails', 'Required parameter "updateCustomFieldDetails" was null or undefined when calling updateCustomField().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UpdateCustomFieldDetailsToJSON)(requestParameters['updateCustomFieldDetails']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates a custom field.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update custom field
     */
    updateCustomField(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCustomFieldRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.IssueFieldsApi = IssueFieldsApi;
/**
 * @export
 */
exports.GetFieldsPaginatedTypeEnum = {
    Custom: 'custom',
    System: 'system'
};
/**
 * @export
 */
exports.GetFieldsPaginatedOrderByEnum = {
    ContextsCount: 'contextsCount',
    ContextsCount2: '-contextsCount',
    ContextsCount3: '+contextsCount',
    LastUsed: 'lastUsed',
    LastUsed2: '-lastUsed',
    LastUsed3: '+lastUsed',
    Name: 'name',
    Name2: '-name',
    Name3: '+name',
    ScreensCount: 'screensCount',
    ScreensCount2: '-screensCount',
    ScreensCount3: '+screensCount',
    ProjectsCount: 'projectsCount',
    ProjectsCount2: '-projectsCount',
    ProjectsCount3: '+projectsCount'
};
/**
 * @export
 */
exports.GetTrashedFieldsPaginatedExpandEnum = {
    Name: 'name',
    Name2: '-name',
    Name3: '+name',
    TrashDate: 'trashDate',
    TrashDate2: '-trashDate',
    TrashDate3: '+trashDate',
    PlannedDeletionDate: 'plannedDeletionDate',
    PlannedDeletionDate2: '-plannedDeletionDate',
    PlannedDeletionDate3: '+plannedDeletionDate',
    ProjectsCount: 'projectsCount',
    ProjectsCount2: '-projectsCount',
    ProjectsCount3: '+projectsCount'
};
//# sourceMappingURL=IssueFieldsApi.js.map